import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getToken } from '../../utils/token';

export const approveApi = createApi({
  reducerPath: 'approveApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL+"/api",
    prepareHeaders: (headers) => {
      const token = getToken();
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getApprove: builder.mutation({
      query: ({ pageIndex, pageSize, sorting, columnFilters, globalFilter,data }) => ({
        url: '/approve',
        method: 'POST',
        body: {
          data,
          pageIndex,
          pageSize,
          sorting,
          filters: columnFilters,
          globalFilter,
        },
      }),
    }),
  }),
});

export const { useGetApproveMutation } = approveApi;
